<template>
  <div>
    <PlatformPve
      ref="platform"
      :bridge="bridge"
      :localStoragePrefix="localStoragePrefix"
      :buttons="buttons"
      :outputs="outputs"
      :uarts="uarts"
      :leds="leds"
      :languages="languages"
      :vbusSpecifications="vbusSpecifications"
      displayType="NT7538"
      @initialized="platformInitialized"
    ></PlatformPve>
  </div>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformPve from '@/device-platforms/PlatformPvm2.vue';

const SpecificationFile = require('resol-vbus/src/specification-file');
const Specification = require('resol-vbus/src/specification');

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformPve,
  },

  data: () => ({
    label: 'Tuxhorn eTherm P9+ 1.11-P40',
    wasmUrl: '100001194_DeltaTherm_PV_MAX_1d11_P40_SN_SS.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      // { platformIndex: 0,conversion: 'voltage', value: null, initialValue: 12.3, name: 'S1', }, // später anpassen
      { platformIndex: 0, conversion: 'resistorPt1000Temperature', value: null, initialValue: 52.3, name: 'S1', }, // Pt1000
      { platformIndex: 1, conversion: 'resistorPt1000Temperature', value: null, initialValue: 55.3, name: 'S2', }, // Pt1000
      { platformIndex: 2, conversion: 'resistorPt1000Temperature', value: null, initialValue: 48.3, name: 'S3', }, // Pt1000
      { platformIndex: 3, conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S4', }, // Pt1000
      { platformIndex: 4, conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S5', }, // Pt1000
      { platformIndex: 5, conversion: 'resistorNTC_MF58_5K_B35Temperature', value: null, initialValue: 44.3, name: 'S6 Kühlk.', }, // NTC_MF58_5K_B35
      { platformIndex: 6, conversion: 'resistorPt1000Temperature', value: null, initialValue: 33.3, name: 'S7 Gehäuse', }, // Pt1000
      // 3xStromsensor
      // { platformIndex: 7, conversion: 'raw', value: null, initialValue: 0.0, name: 'I1', },
      // { platformIndex: 8, conversion: 'raw', value: null, initialValue: 0.0, name: 'I2', },
      // { platformIndex: 9, conversion: 'raw', value: null, initialValue: 0.0, name: 'I3', },
      { platformIndex: 10, conversion: 'frequencyFAN', value: null, initialValue: 0, name: 'S10 Lüfter', }, // TODO Frequenz
      { platformIndex: 11, conversion: 'voltage', value: null, initialValue: 0, name: '10V In', },
      // { platformIndex: 12, conversion: 'rawPercent', value: null, initialValue: 0, name: 'Pwm In', },
      // { platformIndex: 13, conversion: 'digital', value: null, initialValue: 0, name: 'DipSwitch', },
      // NOTE(SKA): I1..3/PwmIn werden aktuell nicht benutzt, da die conversion aus SensorButton.vue zurzeit einen falschen INPUT_OUTPUT_TYPE zurückgibt, was für Input-Entity-Fehler sorgt
      { platformIndex: 14, conversion: 'voltageGaTemperature', value: null, initialValue: 30, name: 'GFA-T', },
      { platformIndex: 15, conversion: 'voltageRpsPressure', value: null, initialValue: 1, name: 'GFA-P', },
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null }, // HochlastRelais
      { name: 'R2', conversion: 'dutycyclePercent', value: null }, // HochlastRelais
      { name: 'R3', conversion: 'dutycyclePercent', value: null }, // HochlastRelais
      { name: 'R4', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R5', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'A1', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
      { name: 'A2', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
      { name: 'FAN', conversion: 'rawDigital', value: null }, // Digital, Lüfter
    ],

    leds: [
        { state: null },
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
      { name: 'UART1', kind: 'VBus', label: 'Intern' },
      { name: 'UART2', kind: 'VBus', label: 'DDS' },
      { name: 'UART3', kind: 'RPC', label: 'Omega' },
      // { name: 'UART4', kind: 'MobBus', label: 'Modbus' },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
    ],
  }),

  created() {
  },

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      let preInitializeCallback = () => {
        this.bridge.setBiosSdCardRootDir("/ETHERM");
        this.bridge.setBiosUpdateFilePattern("TETP????.RSF");
      };

      this.$refs.platform.biosCustomizationId = 100000365;
      this.$refs.platform.prepareBridgeable(preInitializeCallback);

      let vsfResponse = await fetch('/vbus_specification.vsf');
      let vsfArrayBuffer = await vsfResponse.arrayBuffer();
      let vsfBuffer = Buffer.from(vsfArrayBuffer);
      let specificationFile = new SpecificationFile(vsfBuffer);
      let specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);

      vsfResponse = await fetch('/vbus_specification_PVM.vsf');
      vsfArrayBuffer = await vsfResponse.arrayBuffer();
      vsfBuffer = Buffer.from(vsfArrayBuffer);
      specificationFile = new SpecificationFile(vsfBuffer);
      specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);

      vsfResponse = await fetch('/vbus_specification_PVSensormodul.vsf');
      vsfArrayBuffer = await vsfResponse.arrayBuffer();
      vsfBuffer = Buffer.from(vsfArrayBuffer);
      specificationFile = new SpecificationFile(vsfBuffer);
      specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
